import { useState } from 'react';
import { Button, Space, Tooltip, message } from 'antd';
import { EyeOutlined, EyeInvisibleOutlined, CopyOutlined } from '@ant-design/icons';

interface MaskedValueProps {
  value: string;
  visibleChars?: number;
  maskChar?: string;
}

export function MaskedValue({ value, visibleChars = 8, maskChar = '•' }: MaskedValueProps) {
  const [isVisible, setIsVisible] = useState(false);

  const getMaskedValue = () => {
    if (!value) return '-';
    if (value.length <= visibleChars) return value;

    const prefix = value.slice(0, visibleChars);
    const masked = maskChar.repeat(Math.min(12, value.length - visibleChars));
    return `${prefix}${masked}`;
  };

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(value);
      message.success('Kopyalandı');
    } catch {
      message.error('Kopyalanamadı');
    }
  };

  return (
    <Space size={4}>
      <code style={{ fontSize: '11px', fontFamily: 'monospace' }}>
        {isVisible ? value : getMaskedValue()}
      </code>
      <Tooltip title={isVisible ? 'Gizle' : 'Göster'}>
        <Button
          type="text"
          size="small"
          icon={isVisible ? <EyeInvisibleOutlined /> : <EyeOutlined />}
          onClick={() => setIsVisible(!isVisible)}
        />
      </Tooltip>
      <Tooltip title="Kopyala">
        <Button
          type="text"
          size="small"
          icon={<CopyOutlined />}
          onClick={copyToClipboard}
        />
      </Tooltip>
    </Space>
  );
}
